import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageIntro } from '@components/Molecules/PageIntro/PageIntro';
import { ProfilingPageIntroDownload } from '@components/Molecules/ProfilingPageIntro/_partials/ProfilingPageIntroDownload';

export const ProfilingPageIntro: FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'profiling.intro',
  });

  const listItems = t('listItems', { returnObjects: true }) as string[];

  return (
    <PageIntro
      className="c-profiling-page-intro"
      title={t('title')}
      subtitle={t('description')}
    >
      <div className="c-profiling-page-intro__content">
        <ul className="c-profiling-page-intro__list">
          {listItems.map(item => (
            <li className="c-profiling-page-intro__item" key={item}>
              {item}
            </li>
          ))}
        </ul>

        <ProfilingPageIntroDownload />
      </div>
    </PageIntro>
  );
};
